import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const WhatWeDoSection = lazy(() => import("./WhatWeDoSection"));
const WhyChooseSection = lazy(() => import("./WhyChooseSection"));
const AdvantageSection = lazy(() => import("./AdvantageSection"));

const Warehouse = () => {
  return (
    <>
      <Helmet>
        <title>
          Warehouse Management System | Real-Time Inventory & Smart Warehouse.
        </title>
        <meta
          name="description"
          content="Optimize warehouse operations with LENTERA’s cloud-based Warehouse Management System. Streamline inventory, track shipments in real time, integrate barcode & RFID, maximize space and boost order fulfillment efficiency."
        />
        <meta
          name="keywords"
          content="Warehouse management system, WMS software, real-time inventory tracking, warehouse automation, barcode and RFID integration, order and shipment management."
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <WhatWeDoSection />
        <WhyChooseSection />
        <AdvantageSection />
      </Suspense>
    </>
  );
};

export default Warehouse;
